<ng-container *transloco="let t">
  @if (showAlways() || hasActivityLinks()) {
    <div class="row justify-content-between mt-3 gy-3">
      <div class="col-12 col-lg-auto">
        <h3 class="text-secondary">
          <lucide-icon [img]="icons.links"></lucide-icon>
          Liens
        </h3>
      </div>
      @if (canEdit()) {
        <div class="col-12 col-lg-auto">
          <div class="d-grid gap-2 d-md-block">
            <button type="button" class="btn btn-sm btn-outline-primary"
                    (click)="editClick()">
              <lucide-icon [img]="icons.edit" [size]="16"></lucide-icon>
              Indiquer des liens
            </button>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-12 my-2 links">
        @if (activity()?.webUrl) {
          <a [href]="activity()?.webUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            {{ socialLabels.web }}
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }
        @if (activity()?.fbUrl) {
          <a [href]="activity()?.fbUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            {{ socialLabels.fb }}
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }
        @if (activity()?.igUrl) {
          <a [href]="activity()?.igUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            {{ socialLabels.ig }}
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }
      </div>
    </div>
  }
</ng-container>
